module.exports = __webpack_public_path__ + "img/31ne.be4664c8.svg";